// ABOUTME: TabView3 tab config for the relation "nooit verkochte producten" report — a single data-grid tab.
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

export const neverSoldConfig = () => {
    return {
        neversold: {
            title: 'never_sold_products',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
        },
    };
};
